import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./serverlist/serverlist.component').then(m => m.ServerlistComponent),
  },
  {
    path: 'attribution',
    loadComponent: () => import('./attribution/attribution.component').then(m => m.AttributionComponent),
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
